<template>
    <div class="row">
        <Loading v-if="showLoading" />
        <div class="col-md-9">
            <div class="row mb-4">
                <div class="col-md-6">
                    <div :class="currentStep == 1 ? 'step-title active' : 'step-title'">انتخاب تصویر</div>
                </div>
                <div class="col-md-6">
                    <div :class="currentStep == 2 ? 'step-title active' : 'step-title'">تعداد بن کارت</div>
                </div>
                <div class="col-md-12 mt-4">
                    <div :style="{display: currentStep == 1 ? 'unset' : 'none'}">
                        <div class="row create-cart-box justify-content-center text-center" v-if="imageSrc">
                            <p class="w-100">تصویر مورد نظر خود را انتخاب کنید</p>
                            <div class="col-md-8 text-center">
                                <img id="image" :src="imageSrc">
                                <button :class="(!imageUrl ? 'btn btn-custom ml-1 btn-dark mt-3' : 'btn btn-custom ml-1 btn-dark')" @click="changeImage">تغییر تصویر</button>
                                <button :class="(!imageUrl ? 'btn btn-primary btn-custom mt-3' : 'btn btn-primary btn-custom')" @click="saveImage">تایید تصویر</button>
                            </div>
                        </div>
                        <div class="row justify-content-center text-center" v-else>
                            <p class="w-100 mb-4">تصویر مورد نظر خود را انتخاب کنید</p>
                            <div class="col-12 mb-4">
                                <div class="row">
                                    <div class="col-md-2 text-right">
                                        <label class="rdiobox"><input name="rdio" type="radio" value="all" v-model="imagesType" checked> <span>همه تصاویر</span></label>
                                    </div>
                                    <div class="col-md-2 text-right">
                                        <label class="rdiobox"><input name="rdio" type="radio" value="system" v-model="imagesType"> <span>تصاویر پیشفرض</span></label>
                                    </div>
                                    <div class="col-md-2 text-right">
                                        <label class="rdiobox"><input name="rdio" type="radio" value="user" v-model="imagesType"> <span>تصاویر آپلود شده</span></label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row" v-if="images.length">
                                    <div class="col-md-4 mb-3" v-for="(image,index) in images" :key="index">
                                        <img class="organization-image" @click="setImageId(image.mediaId)" :src="`https://cardapi.sabinarya.com/${image.picUrl}`" alt="">
                                    </div>
                                </div>
                                <div class="row" v-else>
                                    <div class="col-md-12">
                                        <div class="alert alert-info">
                                            <p class="mb-0">تصویری یافت نشد</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div :style="{display: currentStep == 2 ? 'unset' : 'none'}">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>تعداد</label>
                                    <input type="number" class="form-control ltr-input" v-model="count" v-on:keyup="count = parseInt(count)">
                                </div>
                            </div>
                            <div class="col-md-3" v-if="!$store.state.userData.isOrganization && !$store.state.userData.isPishkhan && false">
                                <div class="form-group">
                                    <label>میزان تخفیف</label>
                                    <input type="tel" class="form-control ltr-input" @keyup="e => changeCustomDepositValue(e)" v-model="discount">
                                </div>
                            </div>
                            <div class="col-md-12 mt-2">
                                <button class="btn btn-success" @click="submit">ثبت درخواست</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <h6 class="custom-card-box-title">پیش نمایش</h6>
            <hr class="mb-4">
            <div id="preview-parent">
                <div id="preview-container" class="mt-3">
                    <img src="/assets/img/giftcard.png" class="card-template">
                    <div id="preview"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cropper from 'cropperjs';
import html2canvas from 'html2canvas';

export default {
    name: 'CustomCard',
    props: ['addToCard','depositsList','customerId'],
    data(){
        return {
            cardType: 3,
            imageSrc: '',
            imageUrl: '',
            customText: '',
            depositId: 0,
            optionalCredit: '',
            itemsCount: 0,
            textColor: 'rgb(244, 244, 244)',
            borderColor: 'rgb(244, 244, 244)',
            fontSize: 14,
            borderSize: 0,
            disableButton: false,
            cardText: '',
            file: '',
            price: 0,
            count: 0,
            currentStep: 1,
            allImages: [],
            images: [],
            imageMediaId: 0,
            texts: [],
            discount: 0,
            imagesType: 'all',
            resultFile: '',
            showLoading: false
        }
    },
    watch: {
        fontSize(value){
            document.getElementById('inner-element').style.fontSize = (value * 2.5) + 'px';
        },
        borderSize(value){
            document.getElementById('inner-element').style.webkitTextStrokeWidth = value + 'px';
        },
        imagesType(value){
            if(value == 'all')
                this.images = this.allImages;
            else if(value == 'system')
                this.images = this.allImages.filter(image => image.byAdmin)
            else
                this.images = this.allImages.filter(image => !image.byAdmin)
        }
    },
    methods: {
        async setImageId(id){
            this.imageMediaId = id;
            const result = await this.$api.get('Organizations/Media/' + this.imageMediaId);;
            this.imageSrc = 'data:image/jpeg;base64,' + result.data.base64;
            let reader = new FileReader();
            reader.onload = e => {
                this.imageSrc = imageUrl;
            }
            setTimeout(() => {
                const image = document.getElementById('image');
                new Cropper(image,{
                    aspectRatio: 91.00 / 58.00,
                    viewMode: 1,
                    preview: '#preview',
                    autoCropArea: 0.8,
                    dragMode: 'move'
                });
            },100);
        },
        changeImage(){
            this.imageSrc = '';
            this.imageUrl = '';
            document.getElementsByClassName('cropper-container')[0].remove();
            document.getElementById('preview').childNodes[0].remove();
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setExcelFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            document.getElementById('input-pan').setAttribute('placeholder',file.name);
        },
        async saveImage(){
            this.disableButton = true;
            document.getElementById('preview-container').style.transform = 'unset';
            html2canvas(document.getElementById('preview-container')).then(canvas => {
                this.imageUrl = canvas.toDataURL('image/png');
            });
            document.getElementById('preview-container').style.transform = 'scale(0.32)';
            await html2canvas(document.getElementById('preview-container')).then(canvas => {
                let base64Data = canvas.toDataURL('image/png').replace('data:image/png;base64,','');
                this.minifyImageUrl = 'data:image/png;base64,' + base64Data;
            });
            document.getElementsByClassName('cropper-container')[0].remove();
            this.disableButton = false;
            this.currentStep = this.currentStep + 1;
        },
        addOrder(){
            this.addToCard(0,'کارت دلخواه',this.cardType,this.imageUrl,this.file);
        },
        getExcelSample(e){
            e.preventDefault();
            this.$api.get('Organizations/Bonus/Order/Sample').then(({data}) => {
                let a = window.document.createElement('a');
                a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result);
                let fileName = data.result;
                a.setAttribute('download',fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            });
        },
        getResultExcelFile(){
            let a = window.document.createElement('a');
            a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + this.resultFile);
            let fileName = this.resultFile;
            a.setAttribute('download',fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
        },
        submit(){
            this.showLoading = true;
            const postedData = {
                domainDataId: this.customerId,
                byCount: true,
                count: this.count,
                base64: this.imageUrl,
                discount: parseInt(this.discount.toString().replace(/,/g,''))
            };
            this.$api.post('Organizations/Bonus/Order',postedData).then(({data}) => {
                this.resultFile = data.result ? data.result.fileString : '';
                if(data.status)
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک !',
                        text: 'ثبت درخواست بن کارت با موفقیت انجام شد',
                    }).then(res => {
                        if(res.isConfirmed){
                            this.$router.push({name: 'foreignBonusCards.index'});
                        }
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.$api.get('Config/CustomCost').then(({data}) => {
            this.price = parseInt(data.result);
        });
        this.$api.get('Organizations/Media?Option=2').then(({data}) => {
            if(data.status && data.result.length){
                this.allImages = data.result.filter(image => image.metadataKeyId == 2 && image.isApproved);
                this.images = data.result.filter(image => image.metadataKeyId == 2 && image.isApproved);
                let texts = [];
                data.result.map(text => {
                    if(text.metadataKeyId == 3 && text.isApproved)
                        texts.push({
                            ...text,
                            value: text.text
                        });
                });
                this.texts = texts;
            }
        });
    }
}
</script>